import { useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useRegisterConnection } from '@atlassian/jira-issue-table-hierarchy/src/controllers/connections-list/index.tsx';
import type { RootConnectionRegister$key } from './__generated__/RootConnectionRegister.graphql';

export const RootConnectionRegister = ({
	issues,
}: {
	issues?: RootConnectionRegister$key | null;
}) => {
	const issueConnection = useFragment(
		graphql`
			fragment RootConnectionRegister on JiraIssueConnection {
				__id
				edges {
					__typename
				}
			}
		`,
		issues ?? null,
	);

	const rootConnectionDetails = useMemo(() => {
		if (issueConnection && issueConnection.__id) {
			return {
				type: 'ROOT_ISSUES' as const,
				connectionId: issueConnection.__id,
				first: issueConnection?.edges?.length ?? 0,
			};
		}

		return undefined;
	}, [issueConnection]);

	useRegisterConnection(rootConnectionDetails);

	return null;
};
